import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/pro-regular-svg-icons";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import axiosConfig from "../../../services/Axios";
import EmptyData from "../../../components/ui/EmptyData";

function PicturesList({
  itemSelected,
  setItemSelected,
  item,
  isAdmin,
  editMode,
}) {
  const { t } = useTranslation();

  const handleDeletePicture = (imagePicture) => {
    Swal.fire({
      text: t("global.form.delete") + " " + imagePicture.originalName + " ?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: t("global.btn.confirm_delete"),
      cancelButtonText: t("global.btn.cancel"),
      customClass: {
        actions: "gap-2 h-20",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        try {
          axiosConfig
            .delete(process.env.REACT_APP_API_URL + imagePicture["@id"])
            .then((response) => {
              if (response?.status === 204) {
                toast.success(t("settings.items.picture_deleted"), {
                  theme: "colored",
                  hideProgressBar: true,
                });

                let newItem = { ...itemSelected };
                newItem.itemPictures = newItem.itemPictures.filter(
                  (ip) => ip["@id"] !== imagePicture["@id"]
                );
                setItemSelected(newItem);
              }
            });
        } catch (e) {
          if (
            e.response?.status !== 200 &&
            e.response?.data["hydra:description"]
          ) {
            toast.error(e.response?.data["hydra:description"]);
          }
        }
      }
    });
  };

  return item.itemPictures.length > 0 ? (
    <div className="grid grid-cols-12 p-3 gap-3 justify-center">
      {item.itemPictures.map((ip, key) => (
        <div
          key={key}
          className="col-span-12 md:col-span-6 lg:col-span-3 bg-white p-3 rounded shadow border relative"
        >
          <img
            src={
              process.env.REACT_APP_API_URL + "/uploads/thumb_" + ip.filePath
            }
            className="h-full w-full object-cover object-center"
          />
          {!editMode && (item.state === "draft" || isAdmin) && (
            <div
              onClick={() => handleDeletePicture(ip)}
              className="cursor-pointer text-red-500 absolute right-2 top-2 p-2 w-8 h-8 text-xs text-center bg-white"
            >
              <FontAwesomeIcon
                icon={faTrashAlt}
                className="transform hover:scale-110"
              />
            </div>
          )}
        </div>
      ))}
    </div>
  ) : (
    <EmptyData className="col-span-12 w-full">
      {t("settings.items.no_picture")}
    </EmptyData>
  );
}

export default PicturesList;
